import React from 'react';

interface PageShellProps {
  header?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
}

const PageShell: React.FC<PageShellProps> = ({
  header,
  children,
  className = '',
  headerClassName = '',
  contentClassName = '',
}) => {
  return (
    <section
      className={`w-full h-full min-h-0 min-w-0 bg-white dark:bg-neutral-950 ${className}`}
    >
      <div className="flex h-full min-h-0 min-w-0 flex-col [--page-padding-x:24px] [--page-padding-top:12px] [--page-padding-bottom:16px] px-[var(--page-padding-x)] pt-[var(--page-padding-top)] pb-[var(--page-padding-bottom)]">
        {header && (
          <div className={`mb-3 flex-shrink-0 ${headerClassName}`}>{header}</div>
        )}
        <div className={`flex-1 min-h-0 min-w-0 ${contentClassName}`}>
          {children}
        </div>
      </div>
    </section>
  );
};

export default PageShell;
